import React, { useEffect, useState } from "react";
import { BsHeart } from "react-icons/bs";
import {
  addCommentService,
  addPollVote,
  deletePostService,
  getGroupPostbyId,
  getGroupPostsService,
  postLikeService,
  reactonComment,
  reactonPost,
} from "../../../services/GroupService";
import { showToastError, showToastSuccess } from "../../../Utils/Helper";
import moment from "moment";
import { useAuth } from "../../../Context/AuthContext";
import Heart from "../../../svg/PostHeartLike.svg";
import Comment from "../../../svg/PostComment.svg";
import Share from "../../../svg/PostShare.svg";
import ThreeDot from "../../../svg/PostThreeDot.svg";
import { useNavigate } from "react-router-dom";
import ReactionIcons from "./ReactionIcons";
import { toastMsg } from "../../../Utils/AllConstant";
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  format,
  isBefore,
  isToday,
  isYesterday,
  parseISO,
} from "date-fns";
import ReactionButton from "./ReactionButton";
import { FaDownload, FaTrash } from "react-icons/fa";
import DeleteModal from "../../../commonComponent/DeleteModal";
import CommentArea from "./CommentArea";
import { FiDownload, FiEye } from "react-icons/fi";
import { toast } from "react-toastify";
// import { useEffect } from "react";
// import '../style.css'

function PostCard({ key, dt, selectedGroup, getGroupPosts }) {
  const auth = useAuth();
  const [likes, setLikes] = useState("");
  const navigate = useNavigate();
  const [openItem, setOpenItem] = useState("");
  const [isCommentClicked, setIsCommentClicked] = useState(false);
  const [replyIndex, setReplyIndex] = useState("");
  const [PostData, setPostData] = useState(dt);
  const [vidImgShow, setVidImgShow] = useState(false);
  const [newComment, setNewComment] = useState();
  const [visibleComment, setVisibleComment] = useState(2);
  const [postId, setPostId] = useState(dt[0]._id);

  useEffect(() => {
    setPostData(dt);
    // setNewComment()
    setPostId(dt[0]._id)
  }, [dt[0]._id]);
  const calT = (date) => {
    let hrs = differenceInHours(new Date(), parseISO(date));
    let min = differenceInMinutes(new Date(), parseISO(date));
    let sec = differenceInSeconds(new Date(), parseISO(date));

    if (hrs) return hrs + " hrs";
    else if (min) return min + " mins";
    else return sec + " secs";
  };

  const handlePostClick = (id) => {
    setPostId(id);
    getGroupPosts();
  };

  const handleCommentShow = () => {
    if (visibleComment < newComment.length) {
      setVisibleComment((prev) => prev + 2);
    } else {
      setVisibleComment(newComment.length);
    }
  };

  // const getGroupPosts = async () => {
  //   try {
  //     const response = await getGroupPostsService(selectedGroup._id);
  //     if (response) {
  //       let valid = response.filter((post) => post._id == dt._id);
  //       if (valid.length !== 0) {
  //         setNewComment(
  //           response.filter((post) => post._id == dt._id)[0].comments
  //         );
  //         setPostData(response.filter((post) => post._id == dt._id)[0]);
  //       } else {
  //         setNewComment(response[0].comments);
  //         setPostData(response[0]);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };


  const deletePostOther = async (postId) => {
    try {
      const response = await deletePostService(postId);

      if (response) {
        showToastSuccess(response?.data || "Post deleted successfully.");
        getGroupPosts();
        // getSessionById()
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const closeAllItems = () => {
    setOpenItem(null);
  };

  const handleCommentReply = (i) => {
    // setIsCommentClicked(!isCommentClicked);
    setReplyIndex(replyIndex == i ? null : i);
  };

  const handleCommentReaction = async (e, id) => {
    const parms = {};
    parms["commentId"] = "";
    parms["reaction"] = e.target.name;
    parms["postId"] = id;
    // console.log(parms);
    // console.log(e.target.name);
    try {
      const response = await reactonPost(parms);
      // console.log(response.status);
      if (response.status === 200) {
        // getForumsById();
        // setAskQuestion("");
        showToastSuccess("Reaction Added successfully");
        getGroupPosts();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  const handleReaction = (index) => {
    setOpenItem(openItem === index ? null : index);
  };

  const postLike = async (postId) => {
    try {
      const response = await postLikeService(postId);
      if (response) {
        showToastSuccess(response?.data || "Post updated successfully.");
        setLikes(response);
        getGroupPosts();
        console.log(likes);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const addComment = async (postId, reply) => {
    try {
      const response = await addCommentService({
        postId: postId,
        comment: reply,
      });
      if (response) {
        showToastSuccess(toastMsg.newReply);
        document.querySelector(`input[name='${postId}']`).value = "";
        getGroupPosts();
        setReplyIndex(null);

      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleVideoPlay = (e) =>{
    e.stopPropagation()
      setVidImgShow(!vidImgShow)
  
  }

  const voteOnPoll = async(e,value,postId) => {
    // e.stopPropagation()
    let parms = {};
    parms["postId"] = postId;
    parms["value"] = value;
    console.log(parms);
    try {
      const response = await addPollVote(parms);
      console.log(response.status)
      if(response === 'Thanks for voting.'){
        showToastSuccess(response || "Post Voted successfully")
        getGroupPosts();
      }
      if(response === 'You already participated in this poll.'){
        showToastError(response || "Already voted")
      }

    } catch (response) {
      showToastError(
        response || "Some error occurred"
      );
        }
  }

  const handleReply = (e) => {
    // setIsCommentClicked(true)
    e.preventDefault();

    let reply = e.target.children[0].value;
    let commentID = e.target.children[0].name;
    let isValid = true;
    // console.log(reply, commentID);
    if (!reply) {
      isValid = false;
    }

    if (isValid) {
      // setLoader(true);
      addComment(commentID, reply);
      setIsCommentClicked(false);
    }

    // console.log(commentID, reply);
  };

  const TotalLength = (x) => {
    let arr = Object.keys(x);
    let totallength = 0;
    arr.forEach((el) => {
      totallength += x[el].length;
    });
    return totallength;
  };
  return (
    <div
      className="bg-white mb-4 px-4 rounded-4 w-100 post"
      key={key}
      onClick={closeAllItems}
      style={{maxHeight:'1050px', overflowY:'scroll', overflowX:'hidden'}}
    >
      {dt.map((PostData) => {
        let doctName = PostData?.document?.map((doct)=>
        {
          let some = doct.split('/')
          return some[some.length - 1]
        }
        )
        // console.log(doctName)
        // let doctName = SplitedURL[]
        return (
          <div
            className="col-md-12 pb-3 mb-5 mt-2 "
            onClick={(e) => {
              e.stopPropagation();
              handlePostClick(PostData._id);
            }}
          >
            <div className="d-flex justify-content-between mb-2 w-100">
              <div className="d-flex justify-content-start gap-2 align-items-center ">
                <div
                  style={{ height: "60px", width: "60px", borderRadius: "50%" }}
                >
                  <img
                    src={PostData?.createdBy?.proPicture}
                    style={{ height: "100%", width: "100%" }}
                    alt=""
                  />
                </div>
                <h5>{PostData?.createdBy?.full_name}</h5>
              </div>
              {/* <div className="d-flex justify-content-end align-items-center ">
                <div className="pe-5">
                  <img src={Share} alt="" />
                </div>
                <div>
                  <img src={ThreeDot} alt="" />
                </div>
              </div> */}
            </div>

            {/* <div>
              <DeleteModal
                                    title={"Delete"}
                                    content1={"Are you sure you want to delete"}
                                    content2={"this post?"}
                                    modalId={"deletePost"}
                                    button2={"No"}
                                    button1={"Yes"}
                                    onDelete={() => deletePostOther(postId)}
                                  />
  
              {state.selectedPost.createdBy._id === auth?.authUser?._id ? (
                                    <span onClick={() => setPostId(state.selectedPost._id)}>
                                      <FaTrash
                                        className="like_group me-0"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deletePost"
                                      />
                                    </span>
                                  ) : null}
            </div> */}
            <div className="d-flex mt-3 ps-2 justify-content-start align-items-center">
              <span className="mb-0">{PostData?.post} </span>
            </div>
            <div style={{ width: "100%" }} className="mb-3 ps-2">
              {PostData?.image?.length != 0 ? (
                <div style={{ height: "150px" }}>
                  <img
                    src={PostData?.image}
                    alt=""
                    onError={(e) => {
                      e.target.src = "images/defaultPlaceholder.jpg"; //replacement image imported above
                    }}
                    className="singlepost_image43 h-100 object-fit-contain"
                  />
                </div>
              ) : null}
              {PostData?.video?.length != 0 ? (
                <div style={{ height: "150px" }}>
                  {vidImgShow ? (
                    <video
                      className="active_dummyimg object-fit-contain"
                      style={{ height: "100%" }}
                      autoPlay
                      id="video"
                      // loop
                      controls
                      onClick={(e)=>handleVideoPlay(e)}
                    >
                      <source src={PostData?.video} type="video/mp4" />
                    </video>
                  ) : (
                    // <img
                    //   src="images/defaultPlaceholder.jpg"
                    //   onClick={() => setVidImgShow(true)}
                    //   className="singlepost_image43 cursor-pointer"
                    // />

                    <>
                      <div style={{ position: "relative", height: "100%" }}>
                        <img
                          src={PostData?.videoThumbnail}
                          onError={(e) => {
                            e.target.src = "images/defaultPlaceholder.jpg"; //replacement image imported above
                          }}
                          alt=""
                          className="singlepost_image43 cursor-pointer h-100"
                          style={{ height: "20%" }}
                        />
                        <img
                          src="https://img.icons8.com/ios11/600/000000/play-button-circled.png"
                          onClick={(e)=>handleVideoPlay(e)}
                          className="play_btn765 cursor-pointer object-fit-contain "
                          alt=""
                          style={{
                            backgroundPosition: "center center",
                            height: "50px",
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              ) : null}
              {PostData?.document?.length != 0 ? (
                <div
                  style={{
                    height: "150px",
                    position: "relative",
                    // borderRadius: "0px",
                    backgroundColor: "black",
                  }}
                >
                  <img
                    src={PostData?.documentThumbnail}
                    onError={(e) => {
                      e.target.src = "images/defaultPlaceholder.jpg"; //replacement image imported above
                    }}
                    alt=""
                    className="singlepost_image43 h-100 object-fit-cover"
                    style={{
                      backgroundPosition: "center center",
                      // borderRadius: "20px",
                    }}
                  />

                  <div
                    className="bg-light d-flex justify-content-between gap-2 align-items-center w-100 position-absolute"
                    style={{ bottom: "-0px", height: "40px", zIndex: "" }}
                  >
                    <span className="ps-3">{doctName[0].slice(0,10) + '...'}</span>
                    {PostData?.document?.map((doct, i) => (
                      <div className="pe-3">
                        <a
                          href={doct}
                          className="text-decoration-none text-black me-3"
                          download
                        >
                          <FaDownload />
                        </a>
                        <a
                          href={doct}
                          className="text-decoration-none text-black"
                          target="_blank"
                        >
                          <FiEye />
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}

              {Object.keys(PostData?.options || {})?.length === 0 ? null : (
                <>
                  {Object.keys(PostData?.options || {}).map((poll) => (
                    <>
                      <div className="w-50 mx-auto">
                        <div className="d-flex justify-content-between ">
                          <p className="mt-1 poll_bartext">{poll}</p>
                          <p className="resFont">
                            {PostData?.options[poll]?.length
                              ? (PostData?.options[poll]?.length /
                                  TotalLength(PostData?.options)) *
                                100
                              : 0}
                            %
                          </p>
                        </div>
                        <div className="progress mb-2 pointer" onClick={(e)=>{voteOnPoll(e,poll,PostData._id);}}>
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                              width: `${
                                PostData?.options[poll]?.length
                                  ? (PostData?.options[poll]?.length /
                                      TotalLength(PostData?.options)) *
                                    100
                                  : 0
                              }%`,
                            }}
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {PostData?.options[poll]?.length
                              ? (
                                  (PostData?.options[poll].length /
                                    TotalLength(PostData?.options)) *
                                  100
                                ).toFixed(1)
                              : 0}
                            %
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </>
              )}

              {/* <div className="d-flex justify-content-between">
                              <p className="singlepost_text mt-3">
                                {PostData?.post}
                              </p>
                              <p className="text-muted mt-3">
                                {Object.keys(PostData?.options).length >
                                0
                                  ? isBefore(
                                      parseISO(PostData?.pollDate),
                                      new Date()
                                    )
                                    ? "Ended"
                                    : `Ends in ${differenceInDays(
                                        parseISO(PostData?.pollDate),
                                        new Date()
                                      )} days`
                                  : ""}
                              </p>
                            </div> */}
            </div>
            <div className="row my-3">
              <div
                className="d-flex align-items-center justify-content-between w-100 ques-foot"
                style={{ color: "rgba(173, 164, 165, 1)" }}
              >
                <div className="d-flex gap-5 fw-semibold">
                  <div className="ms-2">
                    {moment(new Date(PostData.createdAt)).fromNow()}
                  </div>
                  <div
                    className="pointer tipReaction"
                    style={{
                      color: "rgba(173, 164, 165, 1)",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReaction(PostData._id);
                    }}
                  >
                    React
                    {openItem === PostData._id && (
                      <ReactionIcons
                        onClick={(e) => handleCommentReaction(e, PostData._id)}
                      />
                    )}
                  </div>
                  <div
                    className="pointer"
                    style={{
                      color: "rgba(173, 164, 165, 1)",
                    }}
                    onClick={() => handleCommentReply(PostData._id)}
                  >
                    Reply
                  </div>
                  <div
                    className=" pointer"
                    onClick={() => deletePostOther(PostData._id)}
                  >
                    Delete
                  </div>
                </div>
                <ReactionButton cm={PostData} likes={PostData.postReactions} />
              </div>
            </div>
            {replyIndex == PostData._id && (
              <div className="row">
                <div className="col-md-12">
                  <div className="btn-group activeforum_chat">
                    <form onSubmit={handleReply} className="d-flex w-100">
                      <input
                        type="text"
                        name={PostData._id}
                        placeholder="Type your reply here..."
                      />
                      <button type="submit">
                        <img src="images/arrow.png" alt="" />
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            )}
            {/* <CommentArea/> */}
            {postId === PostData?._id && PostData.comments ? (
              <CommentArea
                dt={PostData}
                selectedGroup={selectedGroup}
                newComment={PostData?.comments}
                setNewComment={setNewComment}
                getGroupPosts={getGroupPosts}
              />
            ) : (
              <CommentArea
                dt={dt}
                selectedGroup={selectedGroup}
                newComment={dt.comments}
                setNewComment={setNewComment}
              />
            )}

            {/* <div className="d-flex justify-content-between align-items-center ques-foot">
            <div className="d-flex align-items-center">
                              <div className="forum_ava forum_ava_sm me-3">
                                <img
                                  src={
                                    state.selectedPost.createdBy.proPicture &&
                                    state.selectedPost.createdBy.proPicture
                                  }
                                  onError={(e) => {
                                    e.target.src = "images/avatar.png"; 
                                  }}
                                  alt=""
                                />
                              </div>
  
                              <p className="mb-0">
                                Posted by
                                <span className="fw-bold text-green">
                                  {" "}
                                  {state.selectedPost.createdBy.full_name}
                                </span>
                              </p>
                            </div>
  
            <div className="d-flex justify-content-between w-100">
              <div>
                Posted By{" "}
                <span className="text-success fw-semibold">
                  {PostData.createdBy.full_name}
                </span>
              </div>
              <span className="ms-2 text-secondary">
                {moment(new Date(PostData.createdAt)).fromNow()}
              </span>
              <div className="reactions bg-gray d-flex align-items-center">
                                    <div className="forum_valid">
                                      {state.selectedPost?.likes?.filter(
                                        (l) => l == auth?.authUser?._id
                                      ).length === 1 ? (
                                        <BsHeartFill
                                          className="icon1 cursor-pointer mt-1"
                                          onClick={() => postLike(state.selectedPost._id)}
                                        />
                                      ) : (
                                        <BsHeart
                                          className="icon1 cursor-pointer mt-1"
                                          onClick={() => postLike(state.selectedPost._id)}
                                        />
                                      )}
                                      {state.selectedPost?.likes ? state.selectedPost?.likes.length : 0}
                                    </div>
  
                                    <div
                                    
                                      className="forum_valid cursor-pointer"
                                      style={{ backgroundColor: "#EC8080" }}
                                      onClick={()=>handleCommentShow(state.selectedPost._id)}
                                    >
                                      <FaCommentDots className="icon1 cursor-pointer mt-1" />
                                      {state.selectedPost?.comments ? state.selectedPost?.comments.length : 0}
                                    </div>
                                    <div className="forum_valid bg-warning">
                                      <FaQuestionCircle className="icon1 cursor-pointer mt-1" />
                                    </div>
                                  </div>
              <ReactionButton cm={PostData} likes={PostData.postReactions} />
            </div>
          </div> */}
            {/* <form onSubmit={handleSubmit}>
                              <div className="row mt-3 mb-0">
                                <div className="col-md-12">
                                  <div
                                    className="btn-group activeforum_chat"
                                    style={{ marginBottom: "0px" }}
                                  >
                                    <input
                                      type="text"
                                      name={state.selectedPost._id}
                                      placeholder="Type your message here..."
                                    />
                                    <button type="submit">
                                      <img src="images/arrow.png" alt="" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form> */}
          </div>
        );
      })}
      {/* <div className="d-flex justify-content-start align-items-center mt-3">
        <div className="d-flex justify-justify-content-between w-50">
          <div className="pe-5">
            {PostData?.likes?.filter((l) => l == auth?.authUser?._id).length ===
            1 ? (
              <img
                src={Heart}
                alt=""
                className=" pointer"
                onClick={() => postLike(PostData._id)}
              />
            ) : (
              <BsHeart
                className="pointer"
                onClick={() => postLike(PostData._id)}
              />
            )}

            <span className="ms-3 fw-semibold fst-italic">
              {PostData?.likes ? PostData?.likes.length : 0}{" "}
              {PostData.likes?.length > 1 ? "likes" : "like"}
            </span>
          </div>
          <div className="">
            <span className="fw-semibold" style={{ fontSize: "18px" }}>
              {PostData?.createdBy?.full_name}
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-end me-5 pointer w-50">
          <div className="pe-5">
            <img src={Share} alt="" />
          </div>
          <div
            className=""
            onClick={() =>
              navigate("/viewgroupposts", {
                state: {
                  selectedPost: PostData,
                  selectedGroup: selectedGroup,
                },
              })
            }
          >
            <img src={Comment} alt="" />{" "}
            <span className="fw-semibold fst-italic">
              {PostData.comments ? PostData.comments.length : 0} comments
            </span>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default PostCard;
